module.exports = __webpack_public_path__ + "img/money.ca2ed8d.svg";